import { useContext } from 'react';
import { LoadingContext } from '../context';

export const useLoading = () => {
  const context = useContext(LoadingContext);
  if (!context) throw new Error('There is no loading provider');
  return context;
};
